jQuery(document).ready(function ($) {
  //##############################################//
  //###*****   Slick slider
  //###*****   Example slider options incl responsive options
  //##############################################//

  // Homepage slider
  $('.js-homepage-slider').each(function () {
    $(this).not('.slick-initialized').slick({
      dots: true,
      arrows: false,
      centerMode: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      fade: true,
      autoplaySpeed: 3000,
      centerPadding: '0px',
      cssEase: 'ease-in-out',
      appendDots: '.c-slider__dots--homepage-slider',
      rows: 0, //Add this to stop an empty div being added before the child HTML
    });
  });

  $('.js-partners-slider').each(function () {
    $(this).slick({
      dots: true,
      arrows: false,
      centerMode: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      centerPadding: '170px',
      infinite: true,
      cssEase: 'linear',
      vertical: true,
      verticalSwiping: true,
      appendDots: '.c-slider__dots--partners',
      rows: 0, //Add this to stop an empty div being added before the child HTML

      responsive: [
        {
          breakpoint: 1600,
          settings: {
            centerPadding: '140px',
          },
        },
        {
          breakpoint: 1400,
          settings: {
            centerPadding: '100px',
          },
        },
        {
          breakpoint: 767,
          settings: {
            centerPadding: '90px',
          },
        },
        {
          breakpoint: 640,
          settings: {
            centerPadding: '90px',
          },
        },
        {
          breakpoint: 480,
          settings: {
            centerPadding: '75px',
          },
        },
      ],
    });
  });

  $('.js-post-carousel').each(function () {
    $(this)
      .not('.slick-initialized')
      .slick({
        dots: true,
        arrows: false,
        centerMode: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 0,
        centerPadding: '70px',
        cssEase: 'ease-in-out',
        appendDots: '.c-slider__dots--post-carousel',
        rows: 0, //Add this to stop an empty div being added before the child HTML
        responsive: [
          {
            breakpoint: 1370,
            settings: {
              arrows: false,
              dots: true,
              // centerMode: false,
              centerPadding: '40px',
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 1170,
            settings: {
              arrows: false,
              dots: true,
              // centerMode: false,
              centerPadding: '40px',
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              dots: true,
              // centerMode: true,
              centerPadding: '40px',
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 520,
            settings: {
              arrows: false,
              dots: true,
              // centerMode: true,
              centerPadding: '70px',
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 420,
            settings: {
              arrows: false,
              dots: true,
              // centerMode: true,
              centerPadding: '50px',
              slidesToShow: 1,
            },
          },
        ],
      });
  });
});
